import React from 'react';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import {
  Close,
  InsertDriveFile,
} from '@mui/icons-material';

const BulkUploadPanelDropzone = ({
  isDragActive,
  maxSizeMb,
  selectedFile,
  onFileSelection,
  onFileChange,
  setIsDragActive,
}) => (
  <>
    <Box
      component="label"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: 'grey.100',
        border: '1px dashed',
        borderColor: isDragActive ? 'primary.main' : 'divider',
        borderRadius: '8px',
        height: '190px',
        padding: '1.5rem',
        cursor: 'pointer',
      }}
      onDragOver={(event) => {
        event.preventDefault();
        setIsDragActive(true);
      }}
      onDragLeave={() => {
        setIsDragActive(false);
      }}
      onDrop={(event) => {
        event.preventDefault();
        const file = event.dataTransfer?.files?.[0] || null;
        if (file) {
          onFileSelection(file);
        }
        setIsDragActive(false);
      }}
    >
      <input
        type="file"
        hidden
        accept=".csv"
        aria-label="Bulk upload CSV"
        onChange={onFileChange}
      />
      <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: 'primary.main' }}>
        Click to upload
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', marginTop: '0.25rem' }}>
        or drag and drop
      </Typography>
      <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', marginTop: '0.75rem' }}>
        .CSV file required (max {maxSizeMb}MB)
      </Typography>
    </Box>

    {selectedFile && (
      <Box
        sx={{
          marginTop: '1rem',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '8px',
          padding: '0.75rem 1rem',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <InsertDriveFile sx={{ color: 'text.secondary' }} />
        <Typography
          sx={{
            flex: 1,
            fontSize: '0.875rem',
            color: 'text.secondary',
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {selectedFile.name}
        </Typography>
        <IconButton
          aria-label="Remove selected file"
          size="small"
          onClick={() => onFileSelection(null)}
          sx={{
            color: 'text.primary',
            padding: 0,
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Box>
    )}
  </>
);

export default BulkUploadPanelDropzone;
